import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Metadata Tab**

gRPC metadata works like HTTP headers.

### 🧾 Supported Use Cases
- Authentication tokens
- Correlation IDs
- Custom headers required by services

### ➕ Adding Metadata
- Key-value based editor
- Supports multiple metadata entries
- Sent with every request message

Metadata is especially useful for **auth**, **tracing**, and **multi-tenant APIs**.
`;

const GRPCMetadataTab = () => {
    return (
        <MarkDownRenderer
            title="Metadata"
            markDownText={markdownContent}
        />
    );
};

export default GRPCMetadataTab;
